module.exports = __webpack_public_path__ + "static/media/ArpitBindal.jpeg:Zone.fbccf14d.Identifier";